<template>
  <div class="home_activity_zone" v-if="show_block">
    <div class="activity_grid">
      <!-- 左：自动轮播 -->
      <div
        class="col_left"
        v-if="left_banner_list.length"
      >
        <swiper
          ref="leftSwiperRef"
          class="left_swiper"
          :options="left_swiper_option_computed"
        >
          <swiper-slide
            v-for="(ad, index) in left_banner_list"
            :key="'lb-' + index"
          >
            <div class="left_slide_inner">
              <img
                class="left_img radius-8px"
                :src="ad.img_path || '/static/images/errorimg.jpg'"
                alt=""
                @error="onImgError"
              />
              <div
                :path="
                  (ad.ad_target || '') +
                  (String(ad.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
                  'sorce=8'
                "
                :username="'gh_5d4bb8e18b8b'"
                class="slide_cl_xcx"
                v-if="is_wx && (ad.ad_type == 7 || ad.ad_type == 8)"
              ></div>
            </div>
          </swiper-slide>
          <div slot="pagination" :class="['swiper-pagination', pag_class]"></div>
        </swiper>
      </div>

      <!-- 右：上静态图 + 下（bottomBanner 轮播 或 bottomAd 两图） -->
      <div
        class="col_right"
      >
        <div
          class="right_top"
          v-if="top_ad && top_ad.img_path"
          ref="rightTopEl"
          @click="adClick(top_ad, 0, flow_area_prefix +'-rightAdTopAd')"
        >
          <img
            class="right_top_img radius-8px"
            :src="top_ad.img_path"
            alt=""
            @error="onImgError"
          />
          <div
            :path="
              (top_ad.ad_target || '') +
              (String(top_ad.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
              'sorce=8'
            "
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="is_wx && (top_ad.ad_type == 7 || top_ad.ad_type == 8)"
          ></div>
        </div>

        <!-- 右下：bottomBanner 竖向轮播（每屏 2 个商品图+价） -->
        <div
          v-if="use_bottom_banner"
          class="right_bottom bottom_banner_mode"
          ref="bottomBannerEl"
          :style="bottom_banner_bg"
          @click="adClick(bottom_banner_obj, 0, flow_area_prefix +'-rightAdBottomBanner')"
        >
          <swiper
            ref="bottomSwiper"
            class="bb_swiper"
            :options="bottom_swiper_option_computed"
          >
            <swiper-slide
              v-for="(pair, pi) in banner_pairs"
              :key="'pair-' + pi"
            >
              <div class="pair_row">
                <div
                  v-for="(it, ii) in pair"
                  :key="'bb-' + pi + '-' + ii"
                  class="bb_card"
                >
                  <img
                    class="bb_img radius-8px"
                    :src="it.img_path || '/static/images/errorimg.jpg'"
                    alt=""
                    @error="onImgError"
                  />
                  <div class="bb_price_tag mt7">
                    <div class="bb_price_left">
                      <img
                        class="bb_price_flame"
                        src="/static/images/priceFlame.png"
                        alt=""
                      />
                    </div>
                    <div class="bb_price_right pb3 pl2">
                      <template v-if="price_parts(it.price)">
                        <span class="bb_currency">¥</span>
                        <span class="bb_price_int f11 fw-b">{{ price_parts(it.price).int }}</span>
                        <span class="bb_price_dec">.{{ price_parts(it.price).dec }}</span>
                      </template>
                      <span v-else class="bb_price_fallback">--</span>
                    </div>
                  </div>
                </div>
                <div v-if="pair.length < 2" class="bb_card bb_card_empty"></div>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <!-- 右下：bottomAd 两张静态图 -->
        <div v-else-if="bottom_ad_list.length" class="right_bottom bottom_ad_static">
          <div
            v-for="(ad, bi) in bottom_ad_list"
            :key="'bad-' + bi"
            class="bottom_ad_cell"
            ref="bottomAdEls"
            @click="adClick(ad, bi, flow_area_prefix +'-rightAdBottomAd' + '-' + (bi + 1))"
          >
            <img
              class="bottom_ad_img radius-8px"
              :src="ad.img_path || '/static/images/errorimg.jpg'"
              alt=""
              @error="onImgError"
            />
            <div
              :path="
                (ad.ad_target || '') +
                (String(ad.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
                'sorce=8'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="is_wx && (ad.ad_type == 7 || ad.ad_type == 8)"
            ></div>
          </div>
          <div v-if="bottom_ad_list.length < 2" class="bottom_ad_cell bottom_ad_cell_empty"></div>
        </div>
        <div v-else-if="product.itemid" class="h-100">
          <product-item
            class="h-100"
            :prolistItem="product"
            :prolistIndex="0"
            :type="'lazyloading'"
            :skuSwitch="'1'"
            @showSku="showSku"
            :markPointData="markPointData"
          ></product-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, checkAgent } from '../../../assets/common/js/config'
import productItem from '../../common/productItem'
import adExposeMixin from '../js/adExposeMixin'

/**
 * activityZone 单项（ajax.js）：
 * leftBanner[], rightAd{ topAd, bottomAd[], bottomBanner{ bgimg, ad_title, ad_type, ad_target, bannerList[{ img_path, price }] } }
 */
export default {
  name: 'homeActivityZone',
  mixins: [adExposeMixin],
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide,
    productItem: productItem
  },
  props: {
    zone: {
      type: Object,
      default: () => ({})
    },
    product: {
      type: Object,
      default: () => ({})
    },
    markPointData: {
      type: Object,
      default: () => ({})
    },
    flow_area_prefix: {
      type: String,
      default: 'activityZone'
    },
    compIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      is_wx: isWeixin() ? 1 : 0,
      pag_class: ''
    }
  },
  created() {
    this.pag_class = 'home_activity_left_pag_' + this._uid
  },
  watch: {
    zone: {
      handler: function () {
        this.scheduleAdExposeBindHandle(this.bindActivityZoneExposeHandle)
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperClickHandler('leftSwiperRef', this.comp_index)
      this.bindActivityZoneExposeHandle()
    })
  },
  computed: {
    left_swiper_option_computed() {
      const n = this.left_banner_list.length
      var that = this
      return {
        loop: n > 1,
        autoplay:
          n > 1
            ? {
                delay: 5000,
                disableOnInteraction: false
              }
            : false,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.' + this.pag_class,
          clickable: true
        },
        on: {
          slideChangeTransitionStart: function () {
            var el = that.$refs.leftSwiperRef && that.$refs.leftSwiperRef.$el
            that.notifyAdExposeCarouselHandle(el)
          },
          click: function () {
            var activeIndex = this.realIndex
            if (checkAgent() != 'Harmony') {
              that.adClick(
                that.left_banner_list[activeIndex],
                activeIndex,
                that.flow_area_prefix +'-leftBanner' + '-' + (activeIndex + 1)
              )
            }
          }
        }
      }
    },
    bottom_swiper_option_computed() {
      const n = this.banner_pairs.length
      var that = this
      return {
        direction: 'vertical',
        loop: n > 1,
        autoplay:
          n > 1
            ? {
                delay: 5000,
                disableOnInteraction: false
              }
            : false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 8
      }
    },
    left_banner_list() {
      const list = this.zone.leftBanner || this.zone.left_banner
      return Array.isArray(list) ? list : []
    },
    right_ad() {
      return this.zone.rightAd || this.zone.right_ad || {}
    },
    top_ad() {
      return this.right_ad.topAd || this.right_ad.top_ad
    },
    bottom_ad_list() {
      const list = this.right_ad.bottomAd || this.right_ad.bottom_ad
      return Array.isArray(list) ? list : []
    },
    bottom_banner_obj() {
      return this.right_ad.bottomBanner || this.right_ad.bottom_banner || {}
    },
    bottom_banner_list() {
      const list = this.bottom_banner_obj.bannerList || this.bottom_banner_obj.banner_list
      return Array.isArray(list) ? list : []
    },
    use_bottom_banner() {
      return this.bottom_banner_list.length > 0
    },
    banner_pairs() {
      const list = this.bottom_banner_list
      const chunks = []
      for (let i = 0; i < list.length; i += 2) {
        chunks.push(list.slice(i, i + 2))
      }
      return chunks.length ? chunks : []
    },
    show_right_col() {
      return (
        (this.top_ad && this.top_ad.img_path) ||
        this.use_bottom_banner ||
        this.bottom_ad_list.length > 0
      )
    },
    show_block() {
      return this.left_banner_list.length > 0 || this.show_right_col
    },
    bottom_banner_bg() {
      const bg = this.bottom_banner_obj.bgimg
      if (!bg) return {}
      return {
        backgroundColor: '#fff5f8',
        backgroundImage: `url(${bg})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center'
      }
    }
  },
  methods: {
    // swiper点击兼容鸿蒙系统
    swiperClickHandler(refName, ref_i) {
      const swiperEl =
        typeof ref_i == 'number' ? this.$refs[refName][ref_i].$el : this.$refs[refName].$el
      const eventType = checkAgent() == 'Harmony' ? 'click' : ''
      if (eventType) {
        swiperEl.addEventListener(eventType, (e) => {
          e.stopPropagation()
          const slideItem = e.target.closest('.swiper-slide')
          if (slideItem) {
            const id = slideItem.dataset.swiperSlideIndex
              ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
              : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
            if (refName == 'leftSwiperRef') {
              this.adClick(
                this.left_banner_list[id],
                id,
                this.flow_area_prefix +'-leftBanner' + '-' + (id + 1)
              )
            }
          }
        })
      }
    },
    format_price(price) {
      if (price == null || price === '') return '--'
      const n = Number(price)
      if (isNaN(n)) return String(price)
      return n.toFixed(2)
    },
    price_parts(price) {
      if (price == null || price === '') return null
      const n = Number(price)
      if (isNaN(n)) return null
      const s = n.toFixed(2)
      const segs = s.split('.')
      return { int: segs[0], dec: segs[1] || '00' }
    },
    bindActivityZoneExposeHandle: function () {
      var that = this
      var left = this.$refs.leftSwiperRef
      if (left && left.$el && this.left_banner_list.length) {
        this.bindAdExposeCarouselHandle(left.$el, {
          get_index: function () {
            if (left.swiper && typeof left.swiper.realIndex === 'number') return left.swiper.realIndex
            return 0
          },
          get_item: function (idx) {
            return that.left_banner_list[idx] || {}
          },
          make_key: function (idx) {
            return that.flow_area_prefix + '-leftBanner-' + (idx + 1)
          }
        })
      }
      if (this.$refs.rightTopEl && this.top_ad) {
        this.bindAdExposeHandle(this.$refs.rightTopEl, this.flow_area_prefix + '-rightAdTopAd', this.top_ad)
      }
      if (this.$refs.bottomBannerEl && this.bottom_banner_obj) {
        this.bindAdExposeHandle(
          this.$refs.bottomBannerEl,
          this.flow_area_prefix + '-rightAdBottomBanner',
          this.bottom_banner_obj
        )
      }
      var bottom_els = this.$refs.bottomAdEls
      var bottom_list = this.bottom_ad_list || []
      if (bottom_els) {
        if (!Array.isArray(bottom_els)) bottom_els = [bottom_els]
        for (var i = 0; i < bottom_els.length; i++) {
          if (bottom_els[i] && bottom_list[i]) {
            this.bindAdExposeHandle(
              bottom_els[i],
              this.flow_area_prefix + '-rightAdBottomAd-' + (i + 1),
              bottom_list[i]
            )
          }
        }
      }
    },
    adClick(ad, index, tag) {
      this.$emit('banner-click', ad, index, tag)
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    },
    showSku(item) {
      this.$emit('showSku', item)
    }
  }
}
</script>

<style scoped lang="scss">
.home_activity_zone {
  margin: 0.1rem 0.11rem 0.12rem;
}

.activity_grid {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0.07rem;
}

.col_left {
  flex: 0 0 49.01%;
  max-width: 49.01%;
  min-width: 0;
  overflow: hidden;

}

.left_swiper {
  height: 2.87rem;
}

.left_slide_inner {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.left_img {
  width: 100%;
  height: 100%;
  display: block;
}

.col_right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  height: 2.87rem;
}

.col_right_full {
  flex: 1 1 100%;
  max-width: 100%;
}

.right_top {
  position: relative;
  overflow: hidden;
  background: #eee;
}

.right_top_img {
  display: block;
  width: 100%;
  height: 1.1rem;
}

.right_bottom {
  flex: 1;
  min-height: 1.6rem;
  overflow: hidden;
}

.bottom_ad_static {
  display: flex;
  flex-direction: row;
  gap: 0.07rem;
  align-items: stretch;
}

.bottom_ad_cell {
  position: relative;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  background: #f7f7f7;
}

.bottom_ad_img {
  display: block;
  width: 100%;
  height: 100%;
}

.bottom_banner_mode {
  padding: 0.33rem 0.1rem 0.1rem;
  box-sizing: border-box;
}

.bb_title {
  margin: 0 0 0.06rem;
  font-size: 0.17rem;
  line-height: 1.3;
  color: #333;
  font-weight: 600;
}

.bb_swiper {
  height: 1.27rem;
}

.pair_row {
  display: flex;
  flex-direction: row;
  gap: 0.07rem;
  align-items: stretch;
  height: 100%;
}

.bb_card {
  flex: 1;
  min-width: 0;
  position: relative;
  overflow: hidden;
}

.bb_img {
  display: block;
  width: 100%;
  height: 1.05rem;
}

.bb_price_tag {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  height: 0.16rem;
  border-radius: 0 0.04rem 0.04rem 0;
  overflow: hidden;
}

.bb_price_flame {
  display: block;
  width: 0.26rem;
  height: 0.16rem;
  object-fit: contain;
  flex-shrink: 0;
}

.bb_price_right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  background: #fff;
  color: #fc0324;
}

.bb_currency {
  font-size: 0.07rem;
  line-height: 1;
}

.bb_price_int {
  line-height: 1;
}

.bb_price_dec {
  font-size: 0.07rem;
  line-height: 1;
}

.bb_price_fallback {
  font-size: 0.11rem;
  font-weight: 600;
  color: #fc0324;
  line-height: 1;
}
</style>

<style lang="scss">
.home_activity_zone [class*='home_activity_left_pag_'] {
  bottom: 0.17rem !important;
  font-size: 0;
}
.home_activity_zone [class*='home_activity_left_pag_'] .swiper-pagination-bullet {
  width: 0.06rem;
  height: 0.06rem;
  background: rgba(0, 0, 0, 0.2);
  opacity: 1;
}
.home_activity_zone [class*='home_activity_left_pag_'] .swiper-pagination-bullet-active {
  background: #FC0324;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeActivityZone.vue